import {NormalDist} from './normal.ts';

export class StaticMarketData {
  static deserialize(data: any): StaticMarketData {
    const j = typeof(data) === 'string' ? JSON.parse(data) : data;

    return new StaticMarketData(
      j.pension_withdrawal_age as number,
      j.state_pension_age as number,
      NormalDist.deserialize(j.taxed_growth_rate as string),
      NormalDist.deserialize(j.untaxed_growth_rate as string),
      j.state_pension_pa as number,
    );
  }

  _pension_withdrawal_age: number; // Can start withdrawing from pension
  _state_pension_age: number; // State pension payments start
  _taxed_growth_rate: NormalDist; // Total return growth rate, less tax (div and CG) and fees
  _untaxed_growth_rate: NormalDist; // Nominal total return growth less fees and inflation
  _state_pension_pa: number; // Pounds per year

  constructor(
    pension_withdrawal_age: number,
    state_pension_age: number,
    taxed_growth_rate: NormalDist,
    untaxed_growth_rate: NormalDist,
    state_pension_pa: number,
  ) {
    this._pension_withdrawal_age = pension_withdrawal_age;
    this._state_pension_age = state_pension_age;
    this._taxed_growth_rate = taxed_growth_rate;
    this._untaxed_growth_rate = untaxed_growth_rate;
    this._state_pension_pa = state_pension_pa;
  }

  serialize(): object {
    return {
      pension_withdrawal_age: this.pension_withdrawal_age,
      state_pension_age: this.state_pension_age,
      taxed_growth_rate: this.taxed_growth_rate.serialize(),
      untaxed_growth_rate: this.untaxed_growth_rate.serialize(),
      state_pension_pa: this.state_pension_pa,
    };
  }

  clone(): StaticMarketData {
    return new StaticMarketData(
      this._pension_withdrawal_age,
      this._state_pension_age,
      this._taxed_growth_rate,
      this._untaxed_growth_rate,
      this._state_pension_pa,
    );
  }

  get pension_withdrawal_age(): number {
    return this._pension_withdrawal_age;
  }

  get state_pension_age(): number {
    return this._state_pension_age;
  }

  get taxed_growth_rate(): NormalDist {
    return this._taxed_growth_rate;
  }

  get untaxed_growth_rate(): NormalDist {
    return this._untaxed_growth_rate;
  }

  get state_pension_pa(): number {
    return this._state_pension_pa;
  }

  zeroVariance(): StaticMarketData {
    const c = this.clone();
    c._untaxed_growth_rate = new NormalDist(this._untaxed_growth_rate.mean, 0);
    c._taxed_growth_rate = new NormalDist(this._taxed_growth_rate.mean, 0);
    return c;
  }
}
